@if (runData) {
    <div class="d-flex flex-column">
        <dx-list class="features-list"
                 [dataSource]="featureConfigItems"
                 [disabled]="submitting"
                 keyExpr="featureName"
                 displayExpr="name"
                 selectionMode="all"
                 [showSelectionControls]="true"
                 [selectedItemKeys]="runData.createTeamBindingModel.teamFeatures"
                 (onSelectionChanged)="onSelectionChanged($event)"
                 selectAllText="Select All"
                 [selectByClick]="true"></dx-list>

        <button adaptButton="refreshLink"
                class="ms-2 d-flex gap-2"
                [disabled]="submitting || !runData.hasCustomisedFeatures"
                (click)="resetToDefault()"
                data-test="add-team-reset-features-button">Reset to default</button>
    </div>
}

<ng-template #createTeamButton>
    <adapt-add-team-create-team-button [instance]="this"></adapt-add-team-create-team-button>
</ng-template>
